import React from 'react';
import { makeStyles } from '@mui/styles';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogContentText from '@mui/material/DialogContentText';
import DialogTitle from '@mui/material/DialogTitle';
import { CloudDownload } from '@mui/icons-material';
import { AdminProgressBar } from '../AdminProgressBar';
import { toCapitalize } from '../../lib/helpers/helpers';

const useStyles = makeStyles((theme) => ({
  form: {
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    width: 'fit-content',
    '& svg': {
      marginBottom: -6,
      marginRight: 4,
    },
    '& input': {
      borderColor: theme.palette.admin.main,
    },
  },
  formControl: {
    marginTop: theme.spacing(2),
    minWidth: 120,
  },
  formControlLabel: {
    marginTop: theme.spacing(3),
    marginLeft: 0,
    '& svg': {
      marginBottom: -6,
    },
  },
}));

const DownloadProgressDialog = ({ type }) => {
  const classes = useStyles();
  return (
    <Dialog
      maxWidth={'sm'}
      fullWidth={true}
      open={true}
      aria-labelledby="add-patient-list-dialog-title"
      className={classes.form}
    >
      <DialogTitle id="add-patient-list-dialog-title">
        <CloudDownload /> Downloading {toCapitalize(type)} Export
      </DialogTitle>
      <DialogContent>
        <AdminProgressBar style={{ margin: '50px auto 50px' }} />
        <DialogContentText>This may take a few minutes, depending on the population size.</DialogContentText>
      </DialogContent>
    </Dialog>
  );
};
export default DownloadProgressDialog;
